if (!customElements.get('teramico-load-more')) {
    customElements.define('teramico-load-more', class extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick || this.loadNext.bind(this);
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.controller) this.controller.abort();
      }
      async loadNext(event) {
        const link = event.target.closest('a');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.loading) return;
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        this.loading = true;
        this.controller = new AbortController();
        link.setAttribute('aria-disabled', 'true');
        this.setAttribute('aria-busy', 'true');
        const line = this.querySelector('.loading-line-container');
        const status = this.querySelector('[data-load-status]');
        line.hidden = false;
        status.textContent = 'Weitere Produkte werden geladen.';
        try {
          const url = new URL(link.href);
          if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Loading failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = html.getElementById('product-grid');
          if (!nextGrid) throw new Error('Product grid missing');
          if (!this.isConnected || document.getElementById('product-grid') !== grid) return;
          const products = Array.from(nextGrid.children);
          grid.append(...products);
          const nextLink = html.querySelector('teramico-load-more a');
          if (nextLink) {
            link.setAttribute('href', nextLink.getAttribute('href'));
          } else {
            link.hidden = true;
            link.style.display = 'none';
          }
          status.textContent = 'Weitere Produkte geladen.';
          if (products.length) {
            products[0].setAttribute('tabindex', '-1');
            products[0].focus({ preventScroll: true });
          }
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            status.classList.remove('visually-hidden');
            status.textContent = 'Laden nicht möglich. Bitte erneut versuchen.';
          }
        } finally {
          this.loading = false;
          line.hidden = true;
          link.removeAttribute('aria-disabled');
          this.removeAttribute('aria-busy');
        }
      }
    });
  }